<header>
  <div class="header-title">
    <gc-text [variant]="'subHeading'">
      {{ 'signing.header' | translate }}
    </gc-text>
  </div>

  <div class="header-actions">
    <app-signing-language-chooser />

    <div class="header-divider" aria-hidden="true"></div>

    @if (isMobileScreen()) {
      <img
        class="header-logo"
        src="../assets/gc-logo-brandmark.svg"
        alt="GlobalConnect logo"
      />
    } @else {
      <img
        class="header-logo"
        src="../assets/global-connect-logo.svg"
        alt="GlobalConnect logo"
      />
    }
  </div>
</header>
<hr />

@if (querySigningData$ | async; as querySigningData) {
  <main>
    @if (querySigningData.isLoading || PDFLoadingState()) {
      <app-overlay />
      <div class="loading-spinner-wrapper">
        <gc-loading-spinner />
        @if (PDFLoadingState()) {
          <gc-text [variant]="'supportiveHeading'">{{
            'signingSummary.confirming' | translate
          }}</gc-text>
        }
      </div>
    } @else {
      @if (querySigningData.error?.status === 404) {
        <app-error-screen-signing-summary [errorType]="'NO_REPORT'" />
      } @else if (querySigningData.error) {
        <app-error-screen-signing-summary [errorType]="'UNKNOWN_ERROR'" />
      } @else if (!querySigningData.data?.canBeSigned) {
        <app-error-screen-signing-summary
          [errorType]="'SIGNING_NOT_AVAILABLE'"
        />
      } @else {
        <app-customer-information />
        <hr />
        <section class="plot-design">
          <gc-text [variant]="'paragraphHeading'">{{
            'signingSummary.plotDesign' | translate
          }}</gc-text>
          <div class="information">
            <gc-text [variant]="'bodyBold'">{{
              'signingSummary.executedDate' | translate
            }}</gc-text>
            <gc-text>{{ signatureDataService.executedDate() }}</gc-text>
          </div>
        </section>
        <app-self-inspections />
        <hr />
        @if (signatureDataService.comment()) {
          <section class="comment">
            <gc-text [variant]="'paragraphHeading'">{{
              'signingSummary.comment' | translate
            }}</gc-text>
            <gc-text [variant]="'largeParagraph'">{{
              signatureDataService.comment()
            }}</gc-text>
          </section>
          <hr />
        }
        <app-signature />
      }
    }
  </main>
}

@if (signingSummaryConfirmationModal()) {
  <app-signing-confirmation-modal />
}
